import { LoadScript, useLoadScript } from "@react-google-maps/api";
import {
  AutoComplete,
  Breadcrumb,
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import { debounce } from "lodash";
import FormItem from "antd/es/form/FormItem";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
export default function AddPackage() {
  const formRef = useRef();
  const { t } = useTranslation();
  const { Panel } = Collapse;
  const navigate = useNavigate();
  const { id } = useParams();
  const PackageId = id ? atob(id) : null;
  const { Option } = Select;
  const [apiLoading, setapiLoading] = useState(false);
  const [weightList, setWeightList] = useState([]);
  const [suburbSearchList, setSuburbSearchList] = useState([]);
  const [options, setOptions] = useState([]);
  const [searchValueBilling, setSearchValueBilling] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const libraries = ["places"];
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const CompanyName = authUserData()?.first_name || ""; // Fetch the company name from authUser Data

  const [form] = Form.useForm();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });
  const [loading, setLoading] = useState(false);

  const initialState = {
    hawb: "",
    customer_code: "",
    customer_name: "",
    customer_phone: "",
    customer_address: "",
    postcode: "",
    customer_zone: "",
    description_of_goods: "",
    special_instructions: "",
    delivery_instructions: "",
    count: "",
    piece_no: "",
    total_pieces: "",
    landed: "",
    weight: "",
    height: "",
    width:"",
    length: "",
    volume_weighted: "",
    shipper_code: "",
    shipper_name: "",
    shipper_address: "",
    shipper_city: "",
    shipper_state: "",
    shipper_postcode: "",
    shipper_country: "",
    origin: "",
    port: "",
    total_value: "",
    goods_currency: "",
    sac: "",
    fr_reference: "",
    sub_master: "",
    pkg_type: "",
    country_of_origin: "",
    cyber_vendor_account: "",
    customs_code: "",
    cyber_importer_account: "",
    importer_abn: "",
    importer_cac: "",
    cyber_supplier_account: "",
    supplier_customs_code: "",
    parcel_no: 0,
    order_no: "",
    status: "",
    is_scanned: false,
    is_picked_up: false,
    delivery_date: "",
    price: "",
    company: CompanyId ? authUserData()?.company : null,
    state: authUserData()?.state ? authUserData()?.state : 1,
    country: authUserData()?.country ? authUserData()?.country : 1,
    suburb: null,
    zone: null,
  };

  const [state, setState] = useState(initialState);
  const [deliverydate, setdeliverydate] = useState(null);
  const [checked, setChecked] = useState(false);
  const [checkedPickedUp, setCheckedPickedUp] = useState(false);
  const [zones, setZones] = useState([]);
  const [postCodes, setPostCodes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  // const [hawbSequence,setHawbSequence]=useState("TY5777");
  // Create a ref to keep track of the latest state
  const stateRef = useRef(state);

  // Update the ref whenever the state changes
  useEffect(() => {
    stateRef.current = state;
  }, [state]);
  useEffect(() => {
    getCompanyList();
  }, []);

  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=true", data).then((response) => {
      setCompanyList(response.data.data);
    });
  };
  //Calling Hawb Sequence at company login time
  // useEffect(() => {
  //   const fetchHawb = async () => {
  //     if (CompanyId && PackageId === null) {
  //       const hawbGenerated = await getHawbSequence();
        
  //       if (hawbGenerated) {
  //         form.setFieldsValue({ hawb: hawbGenerated });
  
  //         setState((prevState) => ({
  //           ...prevState,
  //           hawb: hawbGenerated,
  //         }));
  //       }
  //     }
  //   };
  
  //   fetchHawb();
  // }, [CompanyId, PackageId]); 



  // const getHawbSequence = async (data) => {
  //   try {
  //     const response = await getRequest("hawb-sequence/", data);
  //     // Normally you would use: return response.data.data;
  //     return "YU34343H"; // Dummy value for now
  //   } catch (error) {
  //     console.error("Error fetching HAWB sequence:", error);
  //     return "YU34343H";
  //   }
  // };
  

  const getPriceByWeight = async (weight) => {
    const currentState = stateRef.current; // Always access the latest state from the ref

    try {
      const response = await getRequest(
        `package-model/get-price-by-delivery-rate/?customer_zone=${currentState?.customer_zone_id}&company=${currentState.company}&weight=${weight}`
      );

      if (response?.status) {
        const { price, currency_name } = response.data;

        setState((prevState) => ({
          ...prevState,
          price,
          currency: currency_name,
        }));

        formRef.current.setFieldsValue({ price: `${price} ${currency_name}` });
      }
    } catch (error) {
      console.error("Error fetching price by weight", error);
    }
  };
  // Debounced version of getPriceByWeight
  const useDebouncedWeightPrice = (getPriceByWeight) => {
    const debouncedFn = useRef(
      debounce((weight) => {
        getPriceByWeight(weight);
      }, 500) // 500ms debounce time
    );

    useEffect(() => {
      return () => {
        debouncedFn.current.cancel(); // cleanup on unmount
      };
    }, []);

    return debouncedFn.current;
  };
  const debouncedGetPriceByWeight = useDebouncedWeightPrice(getPriceByWeight);
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const phoneValidLength = state?.customer_phone;
  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 8) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }

    return Promise.resolve();
  };
  const handlePostCodeChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      postcode: value,
    }));
    const selectedpostCodes = postCodes.find(
      (postcode) => postcode.id === value
    );
    console.log("selectedpostCodes", selectedpostCodes);
    const postCodeName = selectedpostCodes ? selectedpostCodes.name : "";
    console.log("postCodeName", postCodeName);
    if (state?.suburb && postCodeName) {
      getCustomerZoneByPostcode(state?.suburb, postCodeName);
    }
  };
  // const handleSuburbChange = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     suburb: value,
  //     postcode: null,
  //   }));
  //   formRef.current.setFieldsValue({ postcode: null });
  //   setPostCodes([]);
  //   getPostCodeBySuburb(value);
  // };

  const searchINBilling = async (value, id) => {
    const apiResponse = await getRequest(
      `suburb/?state_id=${state?.state}&search_area=${value}`
    );

    if (apiResponse.data.results.success) {
      setSuburbSearchList(apiResponse.data.results.data);
    }
  };

  const handleWeightChange = useCallback(
    (e) => {
      const value = e.target.value;

      setState((prevState) => ({
        ...prevState,
        weight: value,
        price: null,
        currency: null,
      }));

      formRef.current.setFieldsValue({ price: null });

      if (state.customer_zone_id && state.company && value) {
        debouncedGetPriceByWeight(value); // Debounced call
      }
    },
    [state, formRef, debouncedGetPriceByWeight]
  );

  const handleCompanyChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        company: value,
        weight: null,
        price: null,
      };
    });
    formRef.current.setFieldsValue({ weight: null, price: null });
  };
  const handleCompanyChangeInput = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        company: CompanyId,
        weight: null,
        price: null,
      };
    });
    formRef.current.setFieldsValue({ company: value });
  };

  const onSearchBilling = async (value, id) => {
    setSearchValueBilling(value);
    value.length >= 3
      ? searchINBilling(!value ? null : value)
      : setSuburbSearchList([]);
  };

  // const getPostCodeBySuburb = async (id) => {
  //   const pincodeResponse = await getRequest(
  //     "pincode/?no_pagination=true&suburb_id=" + id
  //   );
  //   const pincode = pincodeResponse?.data?.data.map((pincode) => ({
  //     id: pincode.id,
  //     name: pincode.pincode,
  //   }));
  //   setPostCodes(pincode);
  // };

  const getPostCodeBySuburb = async (id) => {
    const pincodeResponse = await getRequest(
      "pincode/?no_pagination=true&suburb_id=" + id
    );
    const pincodeData = pincodeResponse?.data?.data;

    if (pincodeData && pincodeData.length > 0) {
      // Assuming you want to set the first pincode as the selected one
      setState((prevState) => ({
        ...prevState,
        postcode: pincodeData[0].pincode, // Set the pincode value
        postcodeId: pincodeData[0].id, // Store the ID of the pincode
      }));
    }
    const pincode = pincodeResponse?.data?.data.map((pincode) => ({
      id: pincode.id,
      name: pincode.pincode,
    }));
    setPostCodes(pincode);
  };
  const handleCountryChnage = (value) => {
    setState((prevState) => ({
      ...prevState,
      country: value,
    }));
  };

  const handleZoneChange = (value) => {
    const selectedZone = zones.find((zone) => zone.id === value);
    const zoneName = selectedZone ? selectedZone.zone : "";
    setState((prevState) => ({
      ...prevState,
      zone: value,
      zone_name: zoneName,
      // suburb: null,
      // postcode: null,
      // weight: null,
      // price: null,
    }));

    formRef.current.setFieldsValue({
      // suburb: null,
      // postcode: null,
      // price: null,
      // weight: null,
    });
    // setSuburbSearchList([]);
    // setWeightList([]);
    // setPostCodes([]);
    getWeightByZone(zoneName); // Pass the zoneName instead of the id
  };

  const getWeightByZone = async (zoneName) => {
    try {
      setapiLoading(true);

      const weightResponse = await getRequest(
        `delivery-rates/?state=${state.state}&zone=${zoneName}&no_pagination=true`
      );

      if (weightResponse.data.success) {
        setWeightList(weightResponse?.data?.data);
      }

      setapiLoading(false);
    } catch {
      ErrorNotificationMsg(t("Error fetching suburb"));
      setapiLoading(false);
    }
  };

  useEffect(() => {
    const zoneGetById = async () => {
      if (PackageId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`package-model/${PackageId}/`);

          if (response.data.success) {
            const {
              id,
              zone_name,
              state_name,
              pincode,
              suburb_name,
              country_name,
              company_name,
              ...filteredResponse
            } = response.data.data;

            setState((prevState) => ({
              ...filteredResponse,
              // postcode: Number(response.data.data.postcode),
              postcode: response.data.data.postcode_name
                ? Number(response.data.data.postcode_name)
                : null, // Handle null
            }));

            const formValues = {
              state: response.data.data.state_name,
              country: response.data.data.country_name,
              suburb: response.data.data.suburb_name,
              zone: response.data.data.zone_name,
              hawb: response.data.data.hawb,
              delivery_date: response.data.data.delivery_date
                ? moment(response.data.data.delivery_date, "DD-MM-YYYY HH:mm")
                : null,
              customer_code: response.data.data.customer_code,
              customer_name: response.data.data.customer_name,
              customer_phone: response.data.data.customer_phone,
              customer_email: response.data.data.customer_email,
              customer_address: response.data.data.customer_address,
              // postcode: Number(response.data.data.postcode),
              postcode: response.data.data.postcode_name
                ? Number(response.data.data.postcode_name)
                : null, // Handle null
              description_of_goods: response.data.data.description_of_goods,
              special_instructions: response.data.data.special_instructions,
              delivery_instructions: response.data.data.delivery_instructions,
              count: response.data.data.count,
              piece_no: response.data.data.piece_no,
              total_pieces: response.data.data.total_pieces,
              landed: response.data.data.landed,
              weight: response.data.data.weight,
              height: response.data.data.height,
              width: response.data.data.width,
              length: response.data.data.length,
              volume_weighted: response.data.data.volume_weighted,
              shipper_code: response.data.data.shipper_code,
              shipper_name: response.data.data.shipper_name,
              shipper_address: response.data.data.shipper_address,
              shipper_city: response.data.data.shipper_city,
              shipper_state: response.data.data.shipper_state,
              shipper_postcode: response.data.data.shipper_postcode,
              shipper_country: response.data.data.shipper_country,
              origin: response.data.data.origin,
              port: response.data.data.port,
              total_value: response.data.data.total_value,
              goods_currency: response.data.data.goods_currency,
              sac: response.data.data.sac,
              fr_reference: response.data.data.fr_reference,
              sub_master: response.data.data.sub_master,
              pkg_type: response.data.data.pkg_type,
              country_of_origin: response.data.data.country_of_origin,
              cyber_vendor_account: response.data.data.cyber_vendor_account,
              customs_code: response.data.data.customs_code,
              cyber_importer_account: response.data.data.cyber_importer_account,
              importer_abn: response.data.data.importer_abn,
              importer_cac: response.data.data.importer_cac,
              cyber_supplier_account: response.data.data.cyber_supplier_account,
              supplier_customs_code: response.data.data.supplier_customs_code,
              parcel_no: response.data.data.parcel_no,
              order_no: response.data.data.order_no,
              status: response.data.data.status,
              is_scanned: response?.data?.data?.is_scanned,
              is_picked_up: response?.data?.data?.is_picked_up,
              price: response?.data?.data?.price,

              company: response?.data?.data?.company, // Use first_name if CompanyId is available
            };

            if (
              response?.data?.data?.suburb &&
              response?.data?.data?.postcode_name
            ) {
              getCustomerZoneByPostcode(
                response.data.data.suburb,
                response.data.data.postcode_name
              );
            }
            getCountryName();
            getStateByCountry(response?.data?.data?.country);
            getzoneByState(response?.data?.data?.state);
            getSuburbByState(response?.data?.data?.state);
            if (response?.data?.data?.suburb) {
              getPostCodeBySuburb(response?.data?.data?.suburb);
            }

            if (formRef.current) {
              formRef.current.setFieldsValue(formValues);
              // formRef.current.setFieldsValue(CompanyId ? authUserData.first_name : "")
            }
          }
        } catch (error) {
          console.error("Error fetching package:", error);
        } finally {
          setapiLoading(false);
        }
      }
    };

    zoneGetById();
  }, [PackageId]);

  useEffect(() => {
    if (PackageId === null) {
      getCountryName();
      authUserData()?.country ? getStateByCountry(1) : getStateByCountry(1);
      authUserData()?.state
        ? getzoneByState(authUserData()?.state)
        : getzoneByState(1);
      authUserData()?.country && authUserData()?.state
        ? formRef.current.setFieldsValue({
            country: authUserData()?.country_name,
            state: authUserData()?.state_name,
          })
        : console.log("");
    }
  }, []);
  const getCustomerZoneByPostcode = async (suburb, postcodeName) => {
    console.log("Customer Zone Get", suburb, postcodeName);
    try {
      const response = await getRequest(
        `package-model/area-by-postcode/?suburb_id=${suburb}&pincode_name=${postcodeName}`
      );

      if (response?.data?.success) {
        console.log("response Area", response.data?.data);
        setState((prevState) => ({
          ...prevState,
          // price,
          // currency,
          customer_zone: response.data?.data?.area_name,
          customer_zone_id: response.data?.data?.area_id,
        }));

        // formRef.current.setFieldsValue({ price: `${price} ${currency}` });
        formRef.current.setFieldsValue({
          customer_zone: response.data?.data?.area_name,
        });
      }
    } catch (error) {
      console.error("Error fetching price by weight", error);
    }
  };

  const getCountryName = async (id) => {
    const stateResponse = await getRequest("country/?no_pagination=true");

    setCountries(stateResponse?.data?.data);
  };
  // const getStateByCountry = async (id) => {
  //   const stateResponse = await getRequest(
  //     "state/?no_pagination=true&country_id=" + id
  //   );

  //   setStates(stateResponse?.data?.data);
  // };
  const getStateByCountry = async (id) => {
    // Use an empty string if `id` is not provided (null, undefined, etc.)
    const countryId = id || "";

    // Make the API request with the appropriate country_id
    const stateResponse = await getRequest(
      `state/?no_pagination=true&country_id=${countryId}`
    );

    // Check if the response contains the expected data and update states
    if (stateResponse?.data?.data) {
      setStates(stateResponse.data.data);
    } else {
      // Optionally, handle the case when the response doesn't contain valid data
      setStates([]);
    }
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      zone: null,
      customer_zone: null,
      suburb: null,
      postcode: null,
      weight: null,
      price: null,
    }));
    formRef.current.setFieldsValue({
      zone: null,
      customer_zone: null,
      suburb: null,
      postcode: null,
      weight: null,
      price: null,
    });
    setSuburbSearchList([]);
    setWeightList([]);
    setPostCodes([]);
    setZones([]);
    getzoneByState(value);
  };
  // const getzoneByState = async (id) => {
  //   const zoneResponse = await getRequest(
  //     "zone/?no_pagination=true&state_id=" + id
  //   );

  //   setZones(zoneResponse?.data?.data);
  // };
  const getzoneByState = async (id) => {
    // If id is not provided (null, undefined, or falsy), use an empty string
    const stateId = id || "";

    // Call the API with the appropriate state_id
    const zoneResponse = await getRequest(
      `zone/?no_pagination=true&state_id=${stateId}`
    );

    // Set the zones data if the response is valid
    if (zoneResponse?.data?.data) {
      setZones(zoneResponse.data.data);
    } else {
      // Optionally, handle the case when the response doesn't contain valid data
      setZones([]);
    }
  };
  // const getSuburbByState = async (id, value, suburb) => {
  //   try {
  //     setapiLoading(true);
  //     const suburbResponse = await getRequest(`suburb/?zone_id=${id}`);
  //     if (suburbResponse.data.results.success) {
  //       setSuburbSearchList(suburbResponse.data.results.data);
  //     }
  //     handleSuburbSearchChange();
  //   } catch {
  //     setapiLoading(false);
  //   }
  // };
  const getSuburbByState = async (id, value, suburb) => {
    try {
      setapiLoading(true);

      // Replace undefined with null (or any other default value)
      const stateId = id === null ? "" : id;

      const suburbResponse = await getRequest(`suburb/?state_id=${stateId}`);

      if (suburbResponse.data.results.success) {
        setSuburbSearchList(suburbResponse.data.results.data);
      }

      handleSuburbSearchChange();
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setapiLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    setState((prevState) => ({
      ...prevState,
      is_scanned: isChecked,
    }));
  };
  const handleCheckboxChangePickUp = (e) => {
    const isChecked = e.target.checked;
    setCheckedPickedUp(isChecked);
    setState((prevState) => ({
      ...prevState,
      is_picked_up: isChecked,
    }));
  };

  const handleSuburbSearchChange = (value) => {
    console.log("Suburb Change", value);
    const selectedSuburb = suburbSearchList.find(
      (option) => option.id === value
    );
    if (selectedSuburb) {
      setState((prevState) => ({
        ...prevState,
        suburb: value,
        postcode: null,
        customer_zone: null,
      }));

      formRef.current.setFieldsValue({
        postcode: null,
        customer_zone: null,
        suburb: selectedSuburb.area,
      });

      setPostCodes([]);
    }
    if (selectedSuburb?.id) {
      getPostCodeBySuburb(selectedSuburb?.id);
    } else {
      console.log("Error in suburb");
    }
  };
  const cleanText = (value) => {
    if (!value) return value;
    return value
      .replace(/\n/g, " ")      // remove newline
      .replace(/\t/g, " ")      // remove tabs
      .replace(/<[^>]*>/g, "")  // remove HTML tags if any
      .replace(/\s+/g, " ")     // collapse extra spaces
      .trim();
  };
  const handleSubmit = async () => {
    const payload = {
      hawb: state.hawb || null,
      customer_code: state.customer_code || null,
      customer_name: state.customer_name || null,
      customer_phone: state.customer_phone || null,
      customer_email: state.customer_email || null,
      customer_email: state.customer_email || null,
      customer_zone: state.customer_zone_id || null,
      //postcode: state.postcode || null,
      postcode: state.postcodeId || null, // This is the pincode ID
      customer_address: state?.customer_address,
      description_of_goods: cleanText(state.description_of_goods) || null,
      special_instructions: cleanText(state.special_instructions) || null,
      delivery_instructions: cleanText(state.delivery_instructions) || null,
      count: state.count || null,
      piece_no: state.piece_no || null,
      total_pieces: state.total_pieces || null,
      landed: state.landed || false,
      weight: state.weight || null,
      shipper_code: state.shipper_code || null,
      shipper_name: state.shipper_name || null,
      shipper_address: state.shipper_address || null,
      shipper_city: state.shipper_city || null,
      shipper_state: state.shipper_state || null,
      shipper_postcode: state.shipper_postcode || null,
      shipper_country: state.shipper_country || null,
      origin: state.origin || null,
      port: state.port || null,
      total_value: state.total_value || null,
      goods_currency: state.goods_currency || null,
      sac: state.sac || false,
      fr_reference: state.fr_reference || null,
      sub_master: state.sub_master || null,
      pkg_type: state.pkg_type || null,
      country_of_origin: state.country_of_origin || null,
      cyber_vendor_account: state.cyber_vendor_account || null,
      customs_code: state.customs_code || null,
      cyber_importer_account: state.cyber_importer_account || null,
      importer_abn: state.importer_abn || null,
      importer_cac: state.importer_cac || null,
      cyber_supplier_account: state.cyber_supplier_account || null,
      supplier_customs_code: state.supplier_customs_code || null,
      is_scanned: state.is_scanned,
      is_picked_up: state.is_picked_up,
      parcel_no: state.parcel_no,
      order_no: state.order_no,
      zone: state.zone || null,
      suburb: state.suburb || null,
      state: state.state || null,
      country: state.country || null,
      height: state.height || null,
      width: state.width || null,
      length: state.length || null,
      volume_weighted: state.volume_weighted || null,
      delivery_date: state.delivery_date || null,
      price: state.price || null,
      company: state.company || null,
      coordinates: state?.coordinates || { latitude: null, longitude: null },
    };

    try {
      setapiLoading(true);
      let response;

      if (PackageId === null) {
        response = await postRequest("package-model/", payload);
      } else {
        response = await patchRequest(`package-model/${PackageId}/`, payload);
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          PackageId === null
            ? t("package_added_successfully")
            : t("package_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        setapiLoading(false);
        setZones([]);
        navigate("/package");
      }
    } catch (error) {
      setapiLoading(false);
    }
  };

  const handleResidentSelectChange = (value) => {
    setState({ ...state, status: value });
  };
  const handleDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY HH:mm");
    setdeliverydate(formattedDate);
    setState({ ...state, delivery_date: formattedDate });
  };
  // const handleSelect = (value) => {
  //   const selected = options.find((option) => option.value === value);
  //   if (selected && selected.place_id) {
  //     const service = new window.google.maps.places.PlacesService(
  //       document.createElement("div")
  //     );
  //     service.getDetails({ placeId: selected.place_id }, (place, status) => {
  //       if (
  //         status === window.google.maps.places.PlacesServiceStatus.OK &&
  //         place
  //       ) {
  //         setState((prevstate) => ({
  //           ...prevstate,
  //           street_address: place.formatted_address,
  //           // suburb:
  //           //   place.address_components.find((ac) =>
  //           //     ac.types.includes("locality")
  //           //   )?.long_name || "",
  //           // state:
  //           //   place.address_components.find((ac) =>
  //           //     ac.types.includes("administrative_area_level_1")
  //           //   )?.short_name || "",
  //           // postcode:
  //           //   place.address_components.find((ac) =>
  //           //     ac.types.includes("postal_code")
  //           //   )?.long_name || "",
  //         }));
  //         form.setFieldsValue({
  //           street_address: place.formatted_address,
  //           // suburb:
  //           //   place.address_components.find((ac) =>
  //           //     ac.types.includes("locality")
  //           //   )?.long_name || "",
  //           // state:
  //           //   place.address_components.find((ac) =>
  //           //     ac.types.includes("administrative_area_level_1")
  //           //   )?.short_name || "",
  //           // postcode:
  //           //   place.address_components.find((ac) =>
  //           //     ac.types.includes("postal_code")
  //           //   )?.long_name || "",
  //         });
  //       }
  //     });
  //   }
  // };

  // const handleSearch = useCallback(
  //   debounce((value) => {
  //     // setLoading(true);

  //     const service = new window.google.maps.places.AutocompleteService();

  //     if (value !== "") {
  //       service.getPlacePredictions({ input: value }, (predictions, status) => {
  //         if (
  //           status === window.google.maps.places.PlacesServiceStatus.OK &&
  //           predictions
  //         ) {
  //           setOptions(
  //             predictions.map((prediction) => ({
  //               value: prediction.description,
  //               place_id: prediction.place_id,
  //             }))
  //           );
  //           setLoading(false);
  //         } else {
  //           setOptions([]);
  //           setLoading(false);
  //         }
  //       });
  //     } else {
  //       setOptions([]);
  //       setLoading(false);
  //       setState((prevstate) => ({
  //         ...prevstate,
  //         street_address: "",
  //         //suburb: "",
  //         // state: "",
  //         // postcode: "",
  //       }));
  //       form.setFieldsValue({
  //         street_address: "",
  //         // suburb: "",
  //         // state: "",
  //         // postcode: "",
  //       });
  //     }
  //   }, 300),
  //   []
  // );
  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );

      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          const latitude = place.geometry.location.lat();
          const longitude = place.geometry.location.lng();

          const suburb =
            place.address_components.find((ac) => ac.types.includes("locality"))
              ?.long_name || "";

          const postcode =
            place.address_components.find((ac) =>
              ac.types.includes("postal_code")
            )?.long_name || "";

          setState((prevstate) => ({
            ...prevstate,
            street_address: place.formatted_address,
            // suburb: suburb,
            // postcode: postcode,
            country: null,
            state: null,
            postcode: null,
            zone: null,
            suburb: null,
            coordinates: {
              latitude: latitude,
              longitude: longitude,
            },
          }));

          form.setFieldsValue({
            street_address: place.formatted_address,
            country: undefined,
            state: undefined,
            postcode: undefined,
            zone: undefined,
            suburb: undefined,
            // suburb: suburb,
            // postcode: postcode,
          });
        }
      });
    }
  };

  const handleSearch = useCallback(
    debounce((value) => {
      const service = new window.google.maps.places.AutocompleteService();

      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
          } else {
            setOptions([]);
          }
        });
      } else {
        setOptions([]);
        setState((prevstate) => ({
          ...prevstate,
          street_address: "",
          country: null,
          state: null,
          postcode: null,
          zone: null,
          suburb: null,
          coordinates: {
            latitude: null,
            longitude: null,
          },
        }));
        form.setFieldsValue({
          street_address: "",

          country: undefined,
          state: undefined,
          postcode: undefined,
          zone: undefined,
          suburb: undefined,
        });
      }
    }, 300),
    []
  );

  return (
    <Spin spinning={apiLoading}>
      <div className="ListingTopBar ">
        <div className="pagenamewrap">
          <div className="pagename">
            {PackageId ? (
              <h3>{t("Edit Package")}</h3>
            ) : (
              <h3>{t("Add Package")}</h3>
            )}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/package"> {t("Package")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {PackageId ? t("Edit Package") : t("Add Package")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Form
            ref={formRef}
            form={form}
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <LoadScript
              googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
              libraries={libraries}
            >
              {/* <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}> */}
              <Collapse defaultActiveKey={["1", "2", "3", "4", "5"]}>
                <Panel
                  header="1. Customer Details"
                  key="1"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      {/* <Form.Item
                      name="company"
                      label={t("pl_company")}
                      rules={[
                        {
                          required: true,
                          message: <Trans>{t("val_company_onboarding")}</Trans>,
                        },
                      ]}
                    >
                      <Select
                        placeholder={t("pl_select_company")}
                        showArrow
                        showSearch
                        name="company"
                        value={state?.company}
                        optionFilterProp="children"
                        onChange={handleCompanyChange}
                        disabled={!!CompanyId} // Disable if CompanyId is available

                      >
                        {companyList.map((company) => (
                          <Option key={company.id} value={company.id}>
                            {company.company_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item> */}

                      {CompanyId ? (
                        <Form.Item
                          // name="company"
                          label={t("pl_company")}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: <Trans>{t("val_company_onboarding")}</Trans>,
                          //   },
                          // ]}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("val_company_onboarding")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Input
                            //label={t("pl_company")}
                            rules={t("val_company_onboarding")}
                            placeholder={t("pl_select_company")}
                            // value={state?.company || CompanyName}  // Set to empty string if you don't want to show first_name
                            value={CompanyName} // Use first_name from authUser Data
                            name="company"
                            disabled
                            handleInputChange={handleCompanyChangeInput}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item
                          name="company"
                          label={t("pl_company")}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("val_company_onboarding")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <Select
                            placeholder={t("pl_select_company")}
                            showArrow
                            showSearch
                            name="company"
                            value={state?.company}
                            optionFilterProp="children"
                            onChange={handleCompanyChange}
                          >
                            {companyList.map((company) => (
                              <Option key={company.id} value={company.id}>
                                {company.company_name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                    {CompanyId ? (
                      <Form.Item
                        name="hawb"
                        label={t("pl_HAWB")}
                        rules={PackageId?
                          [{
                           required:true,
                           message:<Trans>{t("val_HAWB")}</Trans>
                          }]:[]
                        }
                       
                      >
                        <Input
                          placeholder={t("pl_HAWB")}
                          type="text"
                          name="hawb"
                          onChange={handleInputChange}
                       
                        />
                      
                      </Form.Item>
                     
                    ):(
                         <Form.Item
                         name="hawb"
                         label={t("pl_HAWB")}
                         rules={[
                           {
                             required: true,
                             message: <Trans>{t("val_HAWB")}</Trans>,
                           },
                           // {
                           //   pattern: /^[a-zA-Z0-9\s]+$/,
                           //   message: (
                           //     <Trans>{t("val_parcel_no_invalid")}</Trans>
                           //   ),
                           // },
                         ]}
                       >
                         <Input
                           placeholder={t("pl_HAWB")}
                           type="text"
                           name="hawb"
                           onChange={handleInputChange}
                           value={state.hawb}
                         />
                       </Form.Item>)}
                       {(!PackageId && CompanyId) &&(
                        <div  style={{ fontSize: "14px", color: "#888", marginTop: "2px" }}>
                             If you don’t fill HAWB, it will be automatically generated.
                        </div>
                      )}  
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customer_code"
                        label={t("pl_Customer_Code")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Customer_Code")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Customer_Code")}
                          name="customer_code"
                          value={state.customer_code}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customer_name"
                        label={t("pl_Customer_Name")}
                        rules={[
                          {
                            required: true,
                          
                            message: <Trans>{t("val_Customer_Name")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pl_Customer_Name")}
                          name="customer_name"
                          value={state.customer_name}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customer_phone"
                        label={t("label_phoneNumber_customer")}
                        placeholder={t("pl_contact_num_customer")}
                        // rules=
                        // {[
                        //   {
                        //     required: true,
                        //     validator: validatePhoneNumber,
                        //      message: <Trans> {t("val_contact_num_customer")}</Trans>,
                        //   },
                        // ]}
                      >
                        <PhoneInput
                          country={"au"}
                          onlyCountries={["au"]}
                          className="PhoneSection"
                          value={state.customer_phone}
                          onChange={(phone) =>
                            setState({ ...state, customer_phone: phone })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={8}
                      xl={3}
                      className="TextFeild"
                    >
                      <EmailField
                        name="customer_email"
                        label={t("Customer Email")}
                        placeholder={t("Enter Email")}
                        // rules={t("Please enter valid email")}
                        value={state?.email}
                        handleInputChange={handleInputChange}
                      />
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={2} className="TextFeild">
                      <FormItem name="parcel_no" label={t("pl_parcel_no")}>
                        <Input
                          placeholder={t("Parcel Number")}
                          name="parcel_no"
                          disabled
                          value={state?.parcel_no}
                          onChange={handleInputChange}
                          type="text"
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={2} className="TextFeild">
                      <FormItem name="order_no" label={t("pl_order_no")}>
                        <Input
                          placeholder={t("Order Number")}
                          name="order_no"
                          value={state?.order_no}
                          onChange={handleInputChange}
                          type="text"
                        />
                      </FormItem>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={2}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="status"
                        label={t("label_status")}
                        value={state?.status}
                        // ]}
                      >
                        <Select
                          disabled
                          showArrow
                          placeholder={t("pl_select_status")}
                          onChange={(value) =>
                            handleResidentSelectChange(value)
                          }
                        >
                          <Option key="Not Scanned" value="Not Scanned">
                            Not Scanned
                          </Option>
                          <Option
                            key="Received in Depo"
                            value="Received in Depo"
                          >
                            Received in Depo
                          </Option>
                          <Option key="In Transit" value="In Transit">
                            Loaded by Driver
                          </Option>
                          <Option
                            key="Loaded by Driver"
                            value="Loaded by Driver"
                          >
                            Loaded by Driver
                          </Option>
                          <Option key="Delivered" value="Delivered">
                            Delivered
                          </Option>
                          <Option key="Failed Delivery" value="Failed Delivery">
                            Failed Delivery
                          </Option>
                          <Option
                            key="RTS- Return to Sender"
                            value="RTS- Return to Sender"
                          >
                            RTS- Return to Sender
                          </Option>
                          <Option
                            key="RD- Return to depo"
                            value="RD- Return to depo"
                          >
                            RD- Return to depo
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      lg={3}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="delivery_date"
                        label={t("pl_package_delivery_date")}
                      >
                        <DatePicker
                          placeholder={t("pl_date")}
                          format="DD-MM-YYYY HH:mm"
                          showTime={true}
                          allowClear={false}
                          value={deliverydate}
                          onChange={handleDateChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("pl_is_scanned")}
                        name="is_scanned"
                        valuePropName="checked"
                        // required
                      >
                        <Checkbox
                          onChange={handleCheckboxChange}
                          checked={checked}
                        ></Checkbox>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("pl_is_picked_up")}
                        name="is_picked_up"
                        valuePropName="checked"
                        // required
                      >
                        <Checkbox
                          onChange={handleCheckboxChangePickUp}
                          checked={checkedPickedUp}
                        ></Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel
                  header="2. Address Details"
                  key="2"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={6} className="TextFeild">
                      {/* <FormItem
                      name="customer_address"
                      label={t("pl_Customer_Address")}
                      rules={[
                        {
                          required: true,
                          message: <Trans>{t("val_Customer_Address")}</Trans>,
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("pl_Customer_Address")}
                        name="customer_address"
                        value={state.customer_address}
                        onChange={handleInputChange}
                        type="text"
                      />
                    </FormItem> */}
                      <Form.Item
                        name="customer_address"
                        label={t("label_street_address")}
                        rules={[
                          {
                            required: true,
                            message: (
                              <Trans>{t("search_company_address")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <AutoComplete
                          id="customer_address"
                          placeholder={t("search_company_address")}
                          options={options}
                          onSearch={handleSearch}
                          onSelect={handleSelect}
                          value={state.customer_address}
                          onChange={(value) => {
                            setState((prevstate) => ({
                              ...prevstate,
                              customer_address: value,
                              country: null,
                              state: null,
                              postcode: null,
                              zone: null,
                              suburb: null,
                            }));
                            form?.setFieldsValue({
                              customer_address: value,
                              country: undefined,
                              state: undefined,
                              postcode: undefined,
                              zone: undefined,
                              suburb: undefined,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="country"
                        label={t("pl_country")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_country")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          placeholder="Select Country"
                          name="country"
                          value={state?.country}
                          showArrow
                          showSearch
                          onChange={handleCountryChnage}
                          optionFilterProp="children"
                        >
                          {countries.map((Country) => (
                            <Option key={Country.id} value={Country.id}>
                              {Country.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="state"
                        label={t("pl_state")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("Please select state")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          name="state"
                          label={t("pl_state")}
                          placeholder={t("pl_select_state")}
                          value={state.state}
                          onChange={handleStateSelectChange}
                          showArrow
                          showSearch
                          optionFilterProp="children"
                        >
                          {states.map((state) => (
                            <Option key={state.id} value={state.id}>
                              {state.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="zone"
                        label={t("pl_zone")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_select_zone")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Select
                          placeholder={t("pl_select_zone")}
                          showArrow
                          disabled={CompanyId ? true : false}
                          showSearch
                          name="zone"
                          value={state?.zone}
                          optionFilterProp="children"
                          onChange={handleZoneChange}
                        >
                          {zones.map((zone) => (
                            <Option key={zone.id} value={zone.id}>
                              {zone.zone}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="suburb"
                        label={t("pl_suburb")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "Please Select A Suburb",
                        //   },
                        // ]}
                      >
                        <AutoComplete
                          className="autoComplete"
                          onSearch={onSearchBilling}
                          value={state.suburb}
                          optionFilterProp="children"
                          allowClear
                          placeholder={t("pl_select_subrub")}
                          onChange={handleSuburbSearchChange}
                          disabled={!state.state}
                        >
                          {suburbSearchList.map((option) => (
                            <Option key={option.id} value={option.id}>
                              {option.area}
                            </Option>
                          ))}
                        </AutoComplete>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="postcode"
                        label={t("pl_Postcode")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Postcode")}</Trans>,
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("pl_enter_select_postcode")}
                          name="postcode"
                          value={state?.postcode}
                          showArrow
                          onChange={handlePostCodeChange}
                          showSearch
                          optionFilterProp="children"
                        >
                          {postCodes?.map((postcode) => (
                            <Option key={postcode.id} value={postcode.id}>
                              {postcode.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={2} className="TextFeild">
                      <Form.Item name="customer_zone" label={t("pl_area")}>
                        <Input
                          placeholder={t("Zone")}
                          name="customer_zone"
                          disabled
                          value={state?.customer_zone}
                          // onChange={handleInputChange}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel
                  header="3. Package Data"
                  key="3"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={4} className="TextFeild">
                      <Form.Item
                        name="description_of_goods"
                        label={t("pl_Description_goods")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Description_goods")}</Trans>,
                        //   },
                        // ]}
                      >
                         <Input.TextArea
                         
                          name="description_of_goods"
                          value={state.description_of_goods}
                          onChange={handleInputChange}
                          placeholder={t("pl_Description_goods")}
                          rows={3}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={4} className="TextFeild">
  <Form.Item
    name="special_instructions"
    label={t("pl_special_instructions")}
  >
    <Input.TextArea
      name="special_instructions"
      value={state.special_instructions}
      onChange={handleInputChange}
      placeholder={t("pl_special_instructions")}
      rows={3}
    />
  </Form.Item>
</Col>

<Col xs={24} sm={12} md={8} lg={4} className="TextFeild">
  <Form.Item
    name="delivery_instructions"
    label={t("pl_delivery_instructions")}
  >
    <Input.TextArea
      name="delivery_instructions"
      value={state.delivery_instructions}
      onChange={handleInputChange}
      placeholder={t("pl_delivery_instructions")}
      rows={3}
    />
  </Form.Item>
</Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="count"
                        label={t("pl_Count")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Count")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ), // Message for invalid input
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="count"
                          value={state.count}
                          onChange={handleInputChange}
                          placeholder={t("pl_Count")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="piece_no"
                        label={t("pl_piece_no")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_piece_no")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ), // Message for invalid input
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="piece_no"
                          value={state.piece_no}
                          onChange={handleInputChange}
                          placeholder={t("pl_piece_no")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="total_pieces"
                        label={t("pl_total_pieces")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_total_pieces")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ), // Message for invalid input
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="total_pieces"
                          value={state.total_pieces}
                          onChange={handleInputChange}
                          placeholder={t("pl_total_pieces")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="">
                      <Form.Item
                        name="landed"
                        label={t("pl_Landed")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Landed")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Radio.Group
                          onChange={handleInputChange}
                          value={state.landed}
                          style={{ display: "flex" }}
                          name="landed"
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="weight"
                        label={t("pl_Weight")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Weight")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="weight"
                          value={state.weight}
                          onChange={handleWeightChange}
                          placeholder={t("pl_Weight")}
                          // disabled={!state.zone || !state.company} // Disable if zone or company is not selected
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="price"
                        label={t("pl_price")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("pl_enter_price")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="price"
                          value={state?.price}
                          disabled={CompanyId ? true : false}
                          onChange={handleInputChange}
                          // disabled
                          placeholder={t("Price By Weight")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="width"
                        label={t("pl_width")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_width")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="width"
                          value={state.width}
                          onChange={handleInputChange}
                          placeholder={t("pl_width")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="height"
                        label={t("pl_Height")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Height")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="height"
                          value={state.height}
                          onChange={handleInputChange}
                          placeholder={t("pl_Height")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="length"
                        label={t("pl_Length")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Length")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="length"
                          value={state.length}
                          onChange={handleInputChange}
                          placeholder={t("pl_Length")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="volume_weighted"
                        label={t("pl_Volume_Weighted")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Volume_Weighted")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="volume_weighted"
                          value={state.volume_weighted}
                          onChange={handleInputChange}
                          placeholder={t("pl_Volume_Weighted")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel
                  header="4. Shipper Data"
                  key="4"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_code"
                        label={t("pl_Shipper_Code")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Shipper_Code")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="shipper_code"
                          value={state.shipper_code}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Code")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_name"
                        label={t("pl_Shipper_Name")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     pattern: /^[a-zA-Z ]+$/,
                        //     message: <Trans>{t("val_Shipper_Name")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="shipper_name"
                          value={state.shipper_name}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Name")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_address"
                        label={t("pl_Shipper_Address")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Shipper_Address")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="shipper_address"
                          value={state.shipper_address}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Address")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_city"
                        label={t("pl_Shipper_City")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_City")} </Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_city"
                          placeholder={t("pl_Shipper_City")}
                          value={state.shipper_city}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_state"
                        label={t("pl_Shipper_State")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_State")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_state"
                          placeholder={t("pl_Shipper_State")}
                          value={state.shipper_state}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_postcode"
                        label={t("pl_Shipper_Postcode")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Shipper_Postcode")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="shipper_postcode"
                          value={state.shipper_postcode}
                          placeholder={t("pl_Shipper_Postcode")}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="shipper_country"
                        label={t("pl_Shipper_Country")}
                        rules={[
                          {
                            required: false,
                            pattern: /^[a-zA-Z ]+$/,
                            message: <Trans>{t("val_Shipper_Country")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          name="shipper_country"
                          value={state.shipper_country}
                          onChange={handleInputChange}
                          placeholder={t("pl_Shipper_Country")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="origin"
                        label={t("pl_Origin")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_Origin")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="origin"
                          value={state.origin}
                          onChange={handleInputChange}
                          placeholder={t("pl_Origin")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="port"
                        label={t("pl_Port")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Port")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="port"
                          value={state.port}
                          onChange={handleInputChange}
                          placeholder={t("pl_Port")}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="total_value"
                        label={t("pl_Total_Value")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("val_Total_Value")}</Trans>,
                          },
                          {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: (
                              <Trans>{t("val_parcel_no_invalid")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          name="total_value"
                          value={state.total_value}
                          onChange={handleInputChange}
                          placeholder={t("pl_Total_Value")}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="goods_currency"
                        label={t("pl_Goods_Currency")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Goods_Currency")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          type="text"
                          name="goods_currency"
                          value={state.goods_currency}
                          onChange={handleInputChange}
                          placeholder={t("pl_Goods_Currency")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Panel>
                <Panel
                  header="5. Additional Info"
                  key="5"
                  style={{ textAlign: "left" }}
                >
                  <Row gutter={[10]}>
                    <Col xs={24} sm={12} md={8} lg={3} className="">
                      <Form.Item
                        name="sac"
                        label={t("pl_SAC")}
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_SAC")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Radio.Group
                          onChange={handleInputChange}
                          value={state.sac}
                          style={{ display: "flex" }}
                          name="sac"
                        >
                          <Radio value={true}>Yes</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="fr_reference"
                        label={t("pl_FR_Reference")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_FR_Reference")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_FR_Reference")}
                          name="fr_reference"
                          value={state.fr_reference}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="sub_master"
                        label={t("Sub Master")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_SubMaster")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("Sub Master")}
                          name="sub_master"
                          value={state.sub_master}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="pkg_type"
                        label={t("pl_Pkg_Type")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Pkg_Type")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Pkg_Type")}
                          name="pkg_type"
                          value={state.pkg_type}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="country_of_origin"
                        label={t("pl_Country_Origin")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Country_Origin")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Country_Origin")}
                          name="country_of_origin"
                          value={state.country_of_origin}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="cyber_vendor_account"
                        label={t("pl_Cyber_Vendor_Account")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: (
                        //       <Trans>{t("val_Cyber_Vendor_Account")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          placeholder={t("pl_Cyber_Vendor_Account")}
                          name="cyber_vendor_account"
                          value={state.cyber_vendor_account}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="customs_code"
                        label={t("pl_Customs_Code")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Customs_Code")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="customs_code"
                          placeholder={t("pl_Customs_Code")}
                          onChange={handleInputChange}
                          value={state.customs_code}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="cyber_importer_account"
                        label={t("pl_Cyber_Importer_Account")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: (
                        //       <Trans>{t("val_Cyber_Importer_Account")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          name="cyber_importer_account"
                          placeholder={t("pl_Cyber_Importer_Account")}
                          onChange={handleInputChange}
                          value={state.cyber_importer_account}
                          type="text"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="importer_abn"
                        label={t("pl_Importer_ABN")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Importer_ABN")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="importer_abn"
                          placeholder={t("pl_Importer_ABN")}
                          onChange={handleInputChange}
                          value={state.importer_abn}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="importer_cac"
                        label={t("pl_Importer_CAC")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: <Trans>{t("val_Importer_CAC")}</Trans>,
                        //   },
                        // ]}
                      >
                        <Input
                          name="importer_cac"
                          placeholder={t("pl_Importer_CAC")}
                          onChange={handleInputChange}
                          value={state.importer_cac}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="cyber_supplier_account"
                        label={t("pl_Cyber_Supplier_Account")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: (
                        //       <Trans>{t("val_Cyber_Supplier_Account")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          name="cyber_supplier_account"
                          placeholder={t("pl_Cyber_Supplier_Account")}
                          onChange={handleInputChange}
                          value={state.cyber_supplier_account}
                          type="text"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={3} className="TextFeild">
                      <Form.Item
                        name="supplier_customs_code"
                        label={t("pl_Supplier_Customs_Code")}
                        // rules={[
                        //   {
                        //     required: false,
                        //     message: (
                        //       <Trans>{t("val_Supplier_Customs_Code")}</Trans>
                        //     ),
                        //   },
                        // ]}
                      >
                        <Input
                          name="supplier_customs_code"
                          placeholder={t("pl_Supplier_Customs_Code")}
                          onChange={handleInputChange}
                          value={state.supplier_customs_code}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <div
                    className="ModalPopupFooter"
                    style={{ float: "inline-end" }}
                  >
                    <ButtonField
                      style={{ background: "white" }}
                      className="CancelGradiantBtn"
                      type="primary"
                      htmlType="button"
                      size="medium"
                      label="Cancel"
                      onClick={() => navigate("/package")}
                    />
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Submit"
                      label={t("save")}
                    />
                  </div>
                </Panel>
              </Collapse>
            </LoadScript>
          </Form>
        </div>
      </section>
    </Spin>
  );
}
